import { render } from "./PreCutPopup.vue?vue&type=template&id=5c366f6d&scoped=true"
import script from "./PreCutPopup.vue?vue&type=script&lang=js"
export * from "./PreCutPopup.vue?vue&type=script&lang=js"

import "./PreCutPopup.vue?vue&type=style&index=0&id=5c366f6d&scoped=true&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c366f6d"]])

export default __exports__